import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  tags: string[];
  status: string;
  rating?: number;
  views?: string;
}

export default function ComicCard({ id, title, author, cover, tags, status, rating, views }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={`${title} - 下拉式漫画`}
          title={`${title} - 下拉式漫画免费在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span
            className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
              status === '连载中'
                ? 'bg-primary-500 text-white'
                : 'bg-secondary-500 text-white'
            }`}
          >
            {status}
          </span>
        </div>
        {rating && (
          <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm px-2 py-0.5 rounded-md">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-xs text-primary-400"></i>
            </div>
            <span className="text-xs text-white font-medium">{rating}</span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate font-heading">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{author}</p>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        {views && (
          <p className="text-[11px] text-foreground-400 mt-2">
            <span className="inline-flex items-center gap-1">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-eye-line text-[10px]"></i>
              </span>
              {views}
            </span>
          </p>
        )}
      </div>
    </Link>
  );
}